import { useCallback, useMemo } from "react";
import * as R from "ramda";
import qs from "qs";
import { getFormat, isNilOrEmpty, useSessionStorage, noop, debugFn, debuggableDomain } from "utils";

const { parse, stringify } = JSON;

const getFlowConfig = (qsParams) => {
  const qsFlowConfig = qsParams.get("flowConfig");
  return R.isNil(qsFlowConfig) ? undefined : parse(qsFlowConfig);
};

const getFlowStateFromCtx = (ctx) => {
  if (isNilOrEmpty(ctx)) return undefined;
  const query = qs.parse(new URL(ctx).search, { ignoreQueryPrefix: true });
  return query["tilia-state"];
};

const debugOn = (data) => data && parse(data).debug === true && debuggableDomain();

export const useSessionCtx = () => {
  const [data, setData] = useSessionStorage("tilia.ac.ctx");
  const [sessionId, setSessionId] = useSessionStorage("tilia.ac.sessionid");
  const debug = debugOn(data) ? debugFn : noop;

  const sessionCtx = useMemo(() => {
    return data ? parse(data) : null;
  }, [data]);

  const setSessionCtx = (location) => {
    const qsParams = new URLSearchParams(location.search);
    const debugFlag = qsParams.get("debug") === "true";
    const intCtx = qsParams.get("ctx");

    const flow = qsParams.get("flow");
    const flowState = getFlowStateFromCtx(intCtx);
    const flowConfig = getFlowConfig(qsParams);

    const authorizedInvoiceId = qsParams.get("authorized_invoice_id");
    const isEscrow = qsParams.get("is_escrow") === "true";

    const format = getFormat();
    const returnUrl = qsParams.get("returnurl");

    const fullWidth = qsParams.get("fullWidth") === "true" ? true : false;
    setData(
      stringify({
        debug: debugFlag,
        flow,
        flowConfig,
        flowState,
        format,
        intCtx,
        returnUrl,
        authorizedInvoiceId,
        isEscrow,
        fullWidth,
      })
    );
  };

  const setSessionCtxFromObject = useCallback(
    (sCtxObject) => {
      setData(stringify(sCtxObject));
    },
    [setData]
  );

  const setFlowState = useCallback(
    (newFlowState) => {
      setData(
        stringify({
          ...parse(data),
          flowState: newFlowState,
        })
      );
    },
    [setData /*data ?*/] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return {
    sessionCtx,
    setSessionCtx,
    setSessionCtxFromObject,
    debug,
    setFlowState,
    setSessionId,
    sessionId,
  };
};
